export enum ERoles {
	ADMIN = 'ADMIN',
	SETTINGS_MANAGER = 'SETTINGS_MANAGER',
	SETTINGS_READONLY = 'SETTINGS_READONLY',
	SCHEDULE_MANAGER = 'SCHEDULE_MANAGER',
	SCHEDULE_READONLY = 'SCHEDULE_READONLY',
	TEMPLATE_ADMIN = 'TEMPLATE_ADMIN',
	TEMPLATE_MANAGER = 'TEMPLATE_MANAGER'
}
